if (!customElements.get('magnify-image')) {
  customElements.define(
    'magnify-image',
    class MagnifyImage extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.zoomRatio = this.getAttribute('data-zoom-ratio') || 2;
        this.image = this.querySelector('img');
        if (!this.image) return;
        // Spinner außerhalb der Component finden
        this.spinner = this.closest('modal-opener')?.querySelector('.loading__spinner');
        this.needsClick = this.image.classList.contains('image-magnify-hover_after_click');
        this.setupEvents();
      }

      setupEvents() {
        if (this.needsClick) {
          this.addEventListener('click', this.toggleMagnify.bind(this));
        } else {
          this.addEventListener('mouseover', this.magnify.bind(this));
          this.addEventListener('mouseleave', this.removeMagnification.bind(this));
        }
        this.addEventListener('mousemove', this.moveWithHover.bind(this));
      }

      toggleMagnify(event) {
        if (this.overlay) {
          this.removeMagnification();
        } else {
          this.magnify(event);
          this.moveWithHover(event); // Ensure that the overlay is positioned correctly on the initial click
        }
      }

      removeMagnification() {
        if (this.overlay) {
          this.overlay.classList.remove('magnification-active');
        }
        this.image.style.opacity = '100%';
        this.toggleLoadingSpinner(false); // Ensure the spinner is hidden
      }

      moveWithHover(event) {
        if (!this.overlay) return;
        const ratio = this.image.height / this.image.width;
        const container = this.getBoundingClientRect();
        const xPosition = event.clientX - container.left;
        const yPosition = event.clientY - container.top;
        const xPercent = `${xPosition / (this.image.clientWidth / 100)}%`;
        const yPercent = `${yPosition / ((this.image.clientWidth * ratio) / 100)}%`;

        this.overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
        this.overlay.style.backgroundSize = `${this.image.width * this.zoomRatio}px`;
      }

      magnify(event) {
        if (this.overlay){
          this.overlay.classList.add('magnification-active');
          return;
        };
        this.toggleLoadingSpinner(true); // Show spinner while loading
        this.createOverlay();
      }

      createOverlay() {
        this.image.style.opacity = '50%';
        this.overlay = document.createElement('div');
        this.overlay.setAttribute('class', 'image-magnify-full-size magnification-active');
        this.overlay.setAttribute('aria-hidden', 'true');
        this.overlay.style.backgroundColor = 'var(--gradient-background)';

        const tempImage = new Image();
        tempImage.src = this.image.src;

        tempImage.onload = () => {
          this.overlay.style.backgroundImage = `url('${tempImage.src}')`;
          this.image.parentElement.insertBefore(this.overlay, this.image);
          this.toggleLoadingSpinner(false); // Hide spinner after loading
        };

        tempImage.onerror = () => {
          this.toggleLoadingSpinner(false); // Hide spinner on error
          console.error('Failed to load image for magnification.');
        };
      }

      toggleLoadingSpinner(show) {
        if (this.spinner) {
          this.spinner.classList.toggle('hidden', !show);
        }
      }
    }
  );
}


